import * as marietta from "../../..";
import { Dialog } from "../../../core/view";
import { ImageType } from "../../manager/interface/APIManager";

interface DocumentFileType {file_name: string, file_path: string};

export class PinPanoramaInputDialog extends Dialog {

    private uploadFile: File = null;

    private selectFile: DocumentFileType = null;

    constructor(draggable: boolean) {
        super(draggable);
    }

    public buildContent(): void {
        const id = 'PinPanoramaInputDialog';
        const title = (marietta.WebCADGlobal.language === 'jp') ? '画像設定' : '';

        const contents = `
            <div class="pinPanoramaContainer">
                <div class="pintextCategory">
                <label><span class="jp">配置場所：</span><span class="en">Type：</span></label>
                <select id="select_pintextCategory" name="select_pintextCategory">
                    ${this.settingOptionContents()}
                </select>
                </div>
                <div class="textWrap">
                    <textarea id="freeCharacterInputText" placeholder=${(marietta.webcad.WebCADGlobal.language === 'jp') ? "文字を入力してください": "please enter text"}></textarea>
                </div>
                <div class="dialogPlanDocumentList">
                    <div class="uploadFileName">
                        <div id="fileImage" class="icon icon-file"></div>
                        <div id="uploadFileName"></div>
                    </div>
                    <div class="drop-zone">
                        <div class="fontSetting">パノラマ画像ファイルをドラッグ&ドロップ</div>
                        <input type="file" name="myFile" id="panoramaFilePicker" accept="image/jpeg,image/jpg,image/png" />
                        <button id="panoramaPictureUploadBtn">ファイルを選択</button>
                        <p class="fontSetting">または</p>
                        <button id="planningPictureUploadBtn">企画からファイルを選択</button>
                    </div>
                </div>
            </div>
        `;

        const footer = `
            <button id="btnDoneTextInput"><span class="jp">ＯＫ</span><span class="en">OK</span></button>
            <button id="btnCancelTextInput"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>
        `;

        this.createDialog(id, title, contents, footer);

        document.getElementById('panoramaPictureUploadBtn').addEventListener('click', this.uploadPicture);
        document.getElementById('panoramaFilePicker').addEventListener('change', this.panoramaFileLoad);
        document.getElementById('planningPictureUploadBtn').addEventListener('click', this.uploadPlanningPicture);
        document.getElementById('btnDoneTextInput')?.addEventListener('click', this.uploadExecute);
        document.getElementById('btnCancelTextInput')?.addEventListener('click', this.close);

        const dropZoneElement = document.querySelector('#PinPanoramaInputDialog .drop-zone');
        dropZoneElement.addEventListener("dragover", (e) => {
            e.preventDefault();
            dropZoneElement.classList.add("drop-zone--over");
        });

        ["dragleave", "dragend"].forEach((type) => {
            dropZoneElement.addEventListener(type, (e) => {
                dropZoneElement.classList.remove("drop-zone--over");
            });
        });

        dropZoneElement.addEventListener("drop", (e: any) => {
            console.log('drop');
            e.preventDefault();

            if (e.dataTransfer.files.length) {

                // 拡張子チェック
                if (!this.typeCheck(e.dataTransfer.files)) {
                    dropZoneElement.classList.remove("drop-zone--over");
                    this.openError(this);
                    return;
                }

                this.uploadFile = e.dataTransfer.files[0];
                this.selectFile = null;
                this.displayUploadFileName(true);
                document.getElementById('uploadFileName').textContent = this.uploadFile.name;
            }
            dropZoneElement.classList.remove("drop-zone--over");
        });
    }

    /** パノラマ画像ファイルを選択 */
    private panoramaFileLoad = (e) => {
        // 拡張子チェック
        if (!this.typeCheck(e.target.files)) {
            this.openError(this);
            return;
        }

        this.uploadFile = e.target.files[0];
        this.selectFile = null;
        this.displayUploadFileName(true);
        document.getElementById('uploadFileName').textContent = this.uploadFile.name;
    }

    private displayUploadFileName(visible: boolean) {
        (<HTMLElement>document.querySelector('#PinPanoramaInputDialog .uploadFileName')).style.display = visible ? 'flex' : 'none';
        if (visible) {
            this.centerDialog();
        }
    }

    private uploadExecute = () => {
        if (!this.uploadFile && !this.selectFile) {
            marietta.webcad.WebCADGlobal.showAlert('ファイルを選択してください。');
            return;
        }

        if (this.selectFile) {
            this.callBack([
                {
                    ...{ file_name: this.selectFile.file_name, file_path: this.selectFile.file_path },
                    ...this.getAttribute()
                }
            ]);
            this.close();
            return;
        }

        marietta.webcad.WebCADGlobal.showBusy('画像保存中...');
        this.registImageFile(this.uploadFile);
    }

    private settingOptionContents(): string {
        let text = '';
        marietta.webcad.WebCADGlobal.pinTextCategory.forEach((pinText) => {
            text += (marietta.webcad.WebCADGlobal.language === 'jp') ?
                    `<option value="${pinText.id}">${pinText.label}</option>` : `<option value="${pinText.id}">${pinText.label_en}</option>`;
        });
        return text;
    }

    private getAttribute() {
        const textAreaVal = (<HTMLInputElement>document.getElementById('freeCharacterInputText')).value.trim();
        return {
            text:              textAreaVal ?? '',
            text_color:        marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_color,
            font_size:         marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size,
            is_bold:           marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_bold,
            is_underline:      marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_italic,
            is_italic:         marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_underline,
            is_strike_through: marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.is_strike_through,
            text_alignment:    marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.text_alignment,
            text_category:     Number((<HTMLSelectElement>document.getElementById('select_pintextCategory')).value)
        };
    }

    /** 画像ファイルの保存とパノラマピン作成 */
    private registImageFile(file: File) {
        if (!file) return;

        const response = marietta.webcad.manager.APIManager.saveImage(file, ImageType.PinPanorama);
        response.then((res) => {
            console.log(res);
            this.callBack([
                {
                    ...{ file_id: res.documents.file_id, file_path: res.documents.file_path },
                    ...this.getAttribute()
                }
            ]);
            marietta.webcad.WebCADGlobal.hideBusy();
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            this.close();
        });
    }

    /** パノラマ画像ファイルをアップロード */
    private uploadPicture = (e) => {
        e.preventDefault();

        // 連続して同じファイルを選択できるように初期化
        (<HTMLInputElement>document.getElementById('panoramaFilePicker')).value = null;
        document.getElementById('panoramaFilePicker').click();
    }

    /** 企画からファイルを選択 */
    private uploadPlanningPicture = () => {
        marietta.webcad.manager.APIManager.selectPlanningDocument((selectDoc: DocumentFileType) => {
            this.selectFile = selectDoc[0];
            this.uploadFile = null;
            this.displayUploadFileName(true);
            document.getElementById('uploadFileName').textContent = selectDoc[0]?.file_name ?? '';
        });
    }

    /**
     * jpg, pngファイル以外を読み込んだ時の処理
     */
    private openError(self: PinPanoramaInputDialog) {
        self.close();

        marietta.webcad.WebCADGlobal.showAlert('ファイル形式を確認してください。', '');
    }

    /**
     * 拡張子チェック
     * jpg, jpeg, pngファイル以外があった場合、falseを返す
     */
    private typeCheck(fileList: FileList): boolean {
        for (let i = 0; i < fileList.length; i++) {
            let file_type = fileList[i].name.split('.').pop().toLowerCase();
            if (!(file_type == 'jpg' || file_type == 'jpeg' || file_type == 'png')) return false;
        }
        return true;
    }

}